import { Navigate } from 'react-router-dom';

export const GallerySlider = () => <Navigate to="/gallery?view=slider" replace />;
